





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TsNewUserForm } from '@/interfaces'

@Component({ name: 'TsAddUserModal' })
export default class TsAddUserModal extends Vue {
  @Prop({ default: '' })
  title!: string;

  @Prop({ default: '' })
  submitButton!: string;

  @Prop({ default: '' })
  modalError!: string;

  user: TsNewUserForm = {
    email: '',
    firstName: '',
    lastName: ''
  };

  @Watch('user.email')
  emailChanged () {
    this.$emit('changed')
  }

  async submit () {
    await this.$validator.validateAll()

    this.$emit('confirm', this.user)
  }
}
